enum AuthenticationType {
    EMAIL_PASSWORD = 'email_password',
    GOOGLE = 'google',
}

export default AuthenticationType;
